module.exports = __webpack_public_path__ + "static/media/buy_donate_map.90476bcb.svg";